import { render } from "./LoginForgotPassword.vue?vue&type=template&id=d4dd94b8&scoped=true"
import script from "./LoginForgotPassword.vue?vue&type=script&lang=js"
export * from "./LoginForgotPassword.vue?vue&type=script&lang=js"

import "./LoginForgotPassword.vue?vue&type=style&index=0&id=d4dd94b8&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4dd94b8"]])

export default __exports__